import { Avatar, Button, Grid, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import LoadingAnimation from "../../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../../Layouts/ButtonsControlled";
import { FormHeading } from "../../../Layouts/Heading";
import {
    RegisterFormInstaller,
    reset,
} from "../../../Redux/InstallerSlice/InstallerSlice";
import uploadImage from "../../../Assets/images/uploadImage.png";
import { CloudUpload, FileUpload } from "@mui/icons-material";

const RegisterForm = ({ nextForm }) => {
    const { isLodaing, isSuccess, isError, errors } = useSelector(
        (state) => state.installer
    );
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            password: "",
            password_confirmation: "",
            company_name: "",
            phone: "",
            business_fax: "",
            address: "",
            date_of_origination: "",
            logo_url: "",
            apcr_path: "",
            agreement_path: "",
            nda_path: "",
        },

        onSubmit: async (values) => {
            const formdata = new FormData();
            formdata.append("name", values.name);
            formdata.append("email", values.email);
            formdata.append("password", values.password);
            formdata.append(
                "password_confirmation",
                values.password_confirmation
            );
            formdata.append("company_name", values.company_name);
            formdata.append("phone", values.phone);
            formdata.append("business_fax", values.business_fax);
            formdata.append("address", values.address);
            formdata.append("date_of_origination", values.date_of_origination);
            formdata.append("logo_url", values.logo_url);
            formdata.append("apcr_path", values.apcr_path);
            formdata.append("agreement_path", values.agreement_path);
            formdata.append("nda_path", values.nda_path);
            await dispatch(RegisterFormInstaller(formdata));
            await dispatch(reset());
        },
    });

    useEffect(() => {
        if (isSuccess) {
            toast.success("successfully registered");
            nextForm();
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    toast.error(errors[key].msg);
                });
            }
            const resetMethod = async () => {
                await dispatch(reset());
            };
            resetMethod();
        }
    }, [dispatch, errors, isError]);

    const handleChangeLogo = (e) => {
        formik.values.logo_url = e.currentTarget.files[0];
    };
    const handleChangeAPCR = (e) => {
        formik.values.apcr_path = e.currentTarget.files[0];
    };
    const handleChangeAgreement = (e) => {
        formik.values.agreement_path = e.currentTarget.files[0];
    };
    const handleChangeNDA = (e) => {
        formik.values.nda_path = e.currentTarget.files[0];
    };

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <FormContainer>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="email"
                                    name="email"
                                    label="Email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    type="password"
                                    id="password"
                                    name="password"
                                    label="Password"
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="password_confirmation"
                                    type="password"
                                    name="password_confirmation"
                                    label="Password Confirmation"
                                    value={formik.values.password_confirmation}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                        </Grid>
                        <FormHeading> Company Info </FormHeading>

                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="company_name"
                                    name="company_name"
                                    label="Company Name"
                                    value={formik.values.company_name}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="phone"
                                    name="phone"
                                    label="Phone"
                                    value={formik.values.phone}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="business_fax"
                                    name="business_fax"
                                    label="Bussiness Fax"
                                    value={formik.values.business_fax}
                                    onChange={formik.handleChange}
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="address"
                                    name="address"
                                    label="Address"
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="date_of_origination"
                                    name="date_of_origination"
                                    label="Date"
                                    type="date"
                                    value={formik.values.date_of_origination}
                                    onChange={formik.handleChange}
                                />
                            </Grid>

                            <Grid
                                item
                                mb={1}
                                xs={12}
                                md={6}
                                className="file-upload-input"
                            >
                                <Typography variant="label" color="gray">
                                    APCR File
                                </Typography>
                                <FileUploadStyle>
                                    <input
                                        type="file"
                                        name="apcr_path"
                                        id="apcr_path"
                                        onChange={(e) => handleChangeAPCR(e)}
                                    />
                                </FileUploadStyle>
                            </Grid>

                            <Grid
                                item
                                mb={1}
                                xs={12}
                                md={6}
                                className="file-upload-input"
                            >
                                <Typography variant="label" color="gray">
                                    Agreement File
                                </Typography>
                                <FileUploadStyle>
                                    <input
                                        type="file"
                                        name="agreement_path"
                                        id="agreement_path"
                                        onChange={(e) =>
                                            handleChangeAgreement(e)
                                        }
                                    />
                                </FileUploadStyle>
                            </Grid>

                            <Grid
                                item
                                mb={1}
                                xs={12}
                                md={6}
                                className="file-upload-input"
                            >
                                <Typography variant="label" color="gray">
                                    NDA File
                                </Typography>
                                <FileUploadStyle>
                                    <input
                                        type="file"
                                        name="nda_path"
                                        id="nda_path"
                                        onChange={(e) => handleChangeNDA(e)}
                                    />
                                </FileUploadStyle>
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <Typography
                                    variant="lable"
                                    id="logo_url"
                                    label="logo"
                                    align="justify"
                                >
                                    <Avatar
                                        alt="Upload logo"
                                        src={uploadImage}
                                        sx={{
                                            width: "7em",
                                            height: "7em",
                                            margin: "auto",
                                        }}
                                    />
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: "700",
                                            color: "#888",
                                        }}
                                        align="center"
                                    >
                                        Logo picture
                                    </Typography>
                                    <Typography
                                        sx={{ color: "#888" }}
                                        variant="h6"
                                        align="center"
                                    >
                                        Any assets used in projects will live
                                        here.
                                        <br></br> Start creating by uploading
                                        your files.
                                    </Typography>
                                </Typography>
                                <Button
                                    mt={3}
                                    mr={2}
                                    ml={2}
                                    fullWidth
                                    variant="contained"
                                    component="label"
                                >
                                    <CloudUpload />
                                    <span mr={2} ml={2}>
                                        Upload
                                    </span>
                                    <input
                                        hidden
                                        accept="image/*"
                                        type="file"
                                        name="logo_url"
                                        id="logo_url"
                                        onChange={(e) => handleChangeLogo(e)}
                                    />
                                </Button>
                            </Grid>
                        </Grid>
                        <PrimaryButton fullWidth type="submit">
                            {isLodaing ? "loading ... " : "Register"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;

const FileUploadStyle = styled.div`
    input {
        cursor: pointer;
        font: inherit;
        letter-spacing: inherit;
        color: currentcolor;
        padding: 4px 0px 5px;
        border: 0px;
        box-sizing: content-box;
        background: none;
        height: 1.4375em;
        margin: 0px;
        -webkit-tap-highlight-color: transparent;
        display: block;
        min-width: 0px;
        width: 100%;
        animation-name: mui-auto-fill-cancel;
        animation-duration: 10ms;
        border-bottom: 3px solid gray;
    }
`;
// input:hover {
// }

export default RegisterForm;
